/* ═══════════════════════════════════════════════════
   Lianne Wishlist – Core JavaScript v16
   localStorage + Cloudflare Worker Sync
   Bundle Support (Single + Multi)
   Last updated: 2026-03-31
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';
  var STORAGE_KEY = 'lianne_wishlist';
  var WORKER_URL = '';
  var STOREFRONT_TOKEN = '';
  var SHOP_DOMAIN = '';

  // Read config injected by Liquid
  var configEl = document.getElementById('lianne-wishlist-config');
  if (configEl) {
    try {
      var cfg = JSON.parse(configEl.textContent);
      STOREFRONT_TOKEN = cfg.storefrontToken || '';
      SHOP_DOMAIN = cfg.shopDomain || '';
      WORKER_URL = cfg.workerUrl || '';
    } catch (e) { /* ignore */ }
  }

  /* ── Wishlist Drawer Toggle (registered early, capture phase) ── */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-wishlist-drawer-toggle]');
    if (!toggle) return;
    if (document.getElementById('wishlist-page-content')) return;
    var drawerEl = document.getElementById('wishlist-drawer');
    if (!drawerEl) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (window.LianneWishlist && window.LianneWishlist.drawer) {
      window.LianneWishlist.drawer.open();
    }
  }, true);

  /* ── Bundle State Capture ── */

  var bundleCapture = {
    /**
     * Detect if current page is a bundle product page.
     * Returns 'multi', 'single', 'simple', or false.
     */
    /**
     * Find the main product form (inside product-form element).
     */
    _findProductForm: function () {
      // Prefer the form inside <product-form> (the main PDP form)
      var pf = document.querySelector('product-form form[action*="/cart/add"]');
      if (pf) return pf;
      // Fallback: any form with bundle inputs
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('input[data-bundle]')) return forms[i];
      }
      return document.querySelector('form[action*="/cart/add"]');
    },

    detectType: function () {
      if (document.querySelector('strickset-handler[group]')) return 'strickset';
      if (document.querySelector('multi-bundle-handler')) return 'multi';
      if (document.querySelector('bundle-variants')) return 'single';
      var form = this._findProductForm();
      if (form && form.querySelector('input[data-bundle]')) return 'simple';
      return false;
    },

    captureStrickset: function () {
      var handler = document.querySelector('strickset-handler[group]');
      if (!handler) return null;

      var group = handler.getAttribute('group') || '';
      var selectors = document.querySelectorAll('strickset-selector[group="' + group + '"]');

      var slots = [];
      var form = handler.productForm || document.querySelector('form[action*="/cart/add"]');
      selectors.forEach(function (sel) {
        var index = parseInt(sel.getAttribute('data-index')) || 0;

        // Variante aus Custom Element lesen
        var variant = sel.getSelectedVariant ? sel.getSelectedVariant() : null;

        // Fallback: Variante aus bereits geschriebenen Form-Inputs lesen
        if (!variant || !variant.id) {
          if (form) {
            var idInput = form.querySelector('input[name="items[' + index + '][id]"][data-strickset-input]');
            if (idInput && idInput.value) variant = { id: idInput.value };
          }
        }

        if (!variant || !variant.id) return;

        var colorNameEl = sel.querySelector('.color-name');
        var colorName = colorNameEl ? colorNameEl.textContent.trim() : (variant.title || '');

        var imgEl = sel.querySelector('.multi-bundle-color-image');
        var imageUrl = imgEl ? (imgEl.src || '') : '';

        var titleEl = sel.querySelector('.prod-title');
        var label = titleEl ? titleEl.textContent.trim() : '';

        // Menge aus Form-Inputs
        var qty = 1;
        if (form) {
          var qtyInput = form.querySelector('input[name="items[' + index + '][quantity]"][data-strickset-input]');
          if (qtyInput) qty = parseInt(qtyInput.value) || 1;
        }

        slots.push({
          label: label || ('Farbe ' + (index + 1)),
          variantId: String(variant.id),
          variantTitle: colorName,
          quantity: qty,
          imageUrl: imageUrl,
          isInstruction: false
        });
      });

      // Auto-Add Items (z.B. Marketing Kit) aus strickset-handler lesen
      if (handler.autoAddItems && handler.autoAddItems.length) {
        handler.autoAddItems.forEach(function (autoItem) {
          if (!autoItem.variantId) return;
          var autoQty = 1;
          if (handler.currentConstellation && handler.currentConstellation[autoItem.index] !== undefined) {
            autoQty = parseInt(handler.currentConstellation[autoItem.index]) || 1;
          }
          if (autoQty === 0) return;
          slots.push({
            label: 'Zubehör',
            variantId: String(autoItem.variantId),
            variantTitle: '',
            quantity: autoQty,
            imageUrl: '',
            isInstruction: false,
            isAutoAdd: true
          });
        });
      }

      // Gedruckte Anleitung: aus instruction-choice Widget lesen (hat Vorrang vor digital auto-add)
      var instructionChoice = document.querySelector('.instruction-choice');
      var printedAdded = false;
      var printedPrice = 0;
      if (instructionChoice && instructionChoice._instructionChoice) {
        var ic = instructionChoice._instructionChoice;
        if (ic.getSelected() === 'printed' && ic.isAvailable && ic.variantId) {
          printedPrice = parseInt(instructionChoice.dataset.printedPrice || '0', 10);
          slots.push({
            label: 'Gedruckte Anleitung',
            variantId: String(ic.variantId),
            variantTitle: 'Gedruckte Anleitung',
            quantity: 1,
            imageUrl: '',
            isInstruction: true,
            isFree: ic.isFree || false
          });
          printedAdded = true;
        }
      }

      // Digitale Anleitung aus Auto-Add (nur wenn keine gedruckte gewählt)
      if (!printedAdded) {
        var digitalId = handler.getAttribute('data-digital-auto-add') || '';
        if (digitalId) {
          slots.push({
            label: 'Anleitung',
            variantId: String(digitalId),
            variantTitle: 'Digitale Anleitung',
            quantity: 1,
            imageUrl: '',
            isInstruction: true
          });
        }
      }

      // Letzter Fallback: alle data-strickset-input id-Inputs lesen wenn noch keine Slots
      if (slots.length === 0 && form) {
        var autoAddVids = (handler.autoAddItems || []).map(function (ai) { return String(ai.variantId); });
        var idInputs = form.querySelectorAll('input[data-strickset-input][name$="[id]"]');
        idInputs.forEach(function (idInput) {
          if (!idInput.value) return;
          var match = idInput.name.match(/^items\[(\d+)\]/);
          if (!match) return;
          var idx = parseInt(match[1]);
          var qtyEl = form.querySelector('input[data-strickset-input][name="items[' + idx + '][quantity]"]');
          var qty = qtyEl ? parseInt(qtyEl.value) || 1 : 1;
          var isAutoAddSlot = autoAddVids.indexOf(String(idInput.value)) !== -1;

          // Bild + Label aus dem entsprechenden strickset-selector Element lesen
          var sel = document.querySelector('strickset-selector[group="' + group + '"][data-index="' + idx + '"]');
          var imageUrl = '';
          var variantTitle = '';
          var label = 'Farbe ' + (idx + 1);
          if (sel) {
            var imgEl2 = sel.querySelector('.multi-bundle-color-image');
            if (imgEl2) imageUrl = imgEl2.src || '';
            var nameEl2 = sel.querySelector('.color-name');
            if (nameEl2) variantTitle = nameEl2.textContent.trim();
            var titleEl2 = sel.querySelector('.prod-title');
            if (titleEl2 && titleEl2.textContent.trim()) label = titleEl2.textContent.trim();
          }

          slots.push({
            label: label,
            variantId: String(idInput.value),
            variantTitle: variantTitle,
            quantity: qty,
            imageUrl: imageUrl,
            isInstruction: false,
            isAutoAdd: isAutoAddSlot
          });
        });
      }

      if (slots.length === 0) return null;

      var title = handler.getAttribute('data-product-title') || '';
      if (!title) {
        var h1 = document.querySelector('.product__title h1, .product__title');
        if (h1) title = h1.textContent.trim();
      }

      var featuredImage = '';
      var featImgEl = document.querySelector('.product__media-item.is-active img, .product__media img');
      if (featImgEl) featuredImage = featImgEl.src || '';

      // Größe aus aktuellem Dropdown
      var globalOptions = {};
      var sizeSelect = document.querySelector('.strickset-size-select, .bundle-size-select');
      if (sizeSelect && sizeSelect.value) {
        var sizeWrapper = sizeSelect.closest('.product-form__input, .bundle-size-dropdown');
        var sizeLabel = sizeWrapper ? sizeWrapper.querySelector('label, .form__label') : null;
        var sizeKey = sizeLabel ? sizeLabel.textContent.trim().replace(/:$/, '') : 'Größe';
        globalOptions[sizeKey] = sizeSelect.value;
      }
      // Mehrdimensionale Selects
      var dimSelects = document.querySelectorAll('.strickset-dimension-select[data-section-id="' + group + '"]');
      dimSelects.forEach(function (sel) {
        if (sel.value) {
          var dimWrapper = sel.closest('.product-form__input');
          var dimLabel = dimWrapper ? dimWrapper.querySelector('label, .form__label') : null;
          var dimKey = dimLabel ? dimLabel.textContent.trim().replace(/:$/, '') : (sel.getAttribute('data-dimension-label') || 'Option');
          globalOptions[dimKey] = sel.value;
        }
      });

      // Preis aus Strickset-Preis-Element — Section-spezifisch um falsches Element zu vermeiden
      var totalPrice = 0;
      var handlerSection = handler.closest('section') || document.querySelector('section.product-section, #shopify-section-main-product, [id*="main-product"]');
      var priceEl = handlerSection ? handlerSection.querySelector('[data-strickset-price], price-money') : document.querySelector('[data-strickset-price], price-money');
      if (priceEl) {
        var priceText = priceEl.textContent.replace(/[^\d,.]/g, '').replace(',', '.');
        totalPrice = parseFloat(priceText) * 100 || 0;
      }
      // Anleitungspreis ist bereits in price-money eingerechnet (via calcPrice),
      // daher hier keine separate Addition nötig.

      return {
        type: 'strickset',
        title: title,
        featuredImage: featuredImage,
        totalPrice: totalPrice,
        currency: 'EUR',
        globalOptions: globalOptions,
        slots: slots,
        allowPartialRemoval: handler.hasAttribute('data-allow-partial')
      };
    },

    /**
     * Capture multi-bundle configuration from DOM.
     */
    captureMulti: function () {
      var handler = document.querySelector('multi-bundle-handler');
      if (!handler || !handler.selectedVariants) return null;

      var slots = [];
      var selectedVariants = handler.selectedVariants;
      var constellation = handler.currentConstellation;

      // Get selectors for labels and images
      var group = handler.getAttribute('group');
      var selectors = document.querySelectorAll('multi-bundle-selector[group="' + group + '"]');

      for (var index in selectedVariants) {
        if (!selectedVariants.hasOwnProperty(index)) continue;
        var variant = selectedVariants[index];
        if (!variant || !variant.id) continue;

        var constellationVal = constellation ? constellation[index] : undefined;
        var qty = (constellationVal !== undefined && constellationVal !== null) ? parseInt(constellationVal) : 1;
        if (constellationVal !== undefined && qty === 0) continue; // Explicitly hidden slot

        // Find the matching selector for label and image
        var selector = null;
        selectors.forEach(function (s) {
          if (s.getAttribute('data-index') === index.toString()) selector = s;
        });

        var label = '';
        var imageUrl = '';
        var colorName = '';
        var isInstruction = false;

        if (selector) {
          var isHidden = selector.classList.contains('bundle-instruction-hidden') || getComputedStyle(selector).display === 'none';
          var productType = selector.getAttribute('data-product-type') || '';
          var variantTitle = variant.title || '';
          var allTitles = (variantTitle + ' ' + productType).toLowerCase();
          isInstruction = isHidden ||
            allTitles.includes('anleitung') ||
            allTitles.includes('strickanleitung') ||
            allTitles.includes('(digital)') ||
            allTitles.includes('digital');

          if (!isInstruction) {
            var titleEl = selector.querySelector('.prod-title');
            if (titleEl) label = titleEl.textContent.trim();

            var imgEl = selector.querySelector('.multi-bundle-color-image');
            if (imgEl) imageUrl = imgEl.src || '';

            var nameEl = selector.querySelector('.color-name');
            if (nameEl) colorName = nameEl.textContent.trim();
          }
        }

        // Instructions always get quantity 1
        if (isInstruction) qty = 1;

        slots.push({
          label: isInstruction ? 'Anleitung' : label,
          variantId: variant.id,
          variantTitle: isInstruction ? (variant.title || 'Strickanleitung') : (colorName || variant.title || ''),
          quantity: qty,
          imageUrl: imageUrl,
          isInstruction: isInstruction
        });
      }

      if (slots.length === 0) return null;

      // Get product title and featured image
      var title = '';
      var titleEl = handler.getAttribute('data-product-title');
      if (titleEl) {
        title = titleEl;
      } else {
        var h1 = document.querySelector('.product__title h1, .product__title');
        if (h1) title = h1.textContent.trim();
      }

      var featuredImage = '';
      var featImgEl = document.querySelector('.product__media-item.is-active img, .product__media img');
      if (featImgEl) featuredImage = featImgEl.src || '';

      // Calculate total price
      var totalPrice = 0;
      for (var i in selectedVariants) {
        if (!selectedVariants.hasOwnProperty(i)) continue;
        var v = selectedVariants[i];
        var q = constellation ? parseInt(constellation[i]) || 0 : 1;
        if (q === 0) continue;
        totalPrice += (v.price || 0) * q;
      }

      // Get selected global options (size, etc.)
      var globalOptions = {};
      var bundleOpts = document.querySelectorAll('multi-bundle-options[data-section-id="' + group + '"] input:checked, bundle-options input:checked');
      bundleOpts.forEach(function (input) {
        var fieldset = input.closest('fieldset, .product-form__input');
        if (fieldset) {
          var legend = fieldset.querySelector('legend, .form__label');
          if (legend) {
            globalOptions[legend.textContent.trim()] = input.value;
          }
        }
      });
      // Also capture size from select dropdowns (rendered outside bundle-options)
      var sizeSelects = document.querySelectorAll('.multi-bundle-size-select, .bundle-size-select');
      sizeSelects.forEach(function (sel) {
        if (sel.value) {
          var wrapper = sel.closest('.bundle-size-dropdown, .product-form__input');
          var label = wrapper ? wrapper.querySelector('label, .form__label') : null;
          var key = label ? label.textContent.trim().replace(/:$/, '') : 'Größe';
          globalOptions[key] = sel.value;
        }
      });

      return {
        type: 'multi',
        title: title,
        featuredImage: featuredImage,
        totalPrice: totalPrice,
        currency: 'EUR',
        globalOptions: globalOptions,
        slots: slots
      };
    },

    /**
     * Capture single-bundle configuration from DOM.
     */
    captureSingle: function () {
      var replacer = document.querySelector('bundle-variants');
      if (!replacer) return null;

      var form = replacer.productForm || this._findProductForm();
      if (!form) return null;

      var slots = [];
      var idInputs = form.querySelectorAll('input[name^="items["][name$="[id]"]');
      var qtyInputs = form.querySelectorAll('input[name^="items["][name$="[quantity]"]');

      idInputs.forEach(function (input, idx) {
        var variantId = input.value;
        var qty = qtyInputs[idx] ? parseInt(qtyInputs[idx].value) || 1 : 1;

        // Find the variant image and color from the single-bundle color fieldsets
        var imageUrl = '';
        var colorName = '';
        var label = '';

        // Instruktions-Erkennung (gleiche Logik wie captureSimple/captureMulti)
        var isInstruction = false;
        var stockEl = document.querySelector('[data-variant-stock="' + variantId + '"]');
        if (stockEl) {
          var isPhysical = stockEl.getAttribute('data-physical');
          var productTitle = (stockEl.getAttribute('data-product-title') || '').toLowerCase();
          isInstruction = isPhysical === 'false' ||
            productTitle.includes('anleitung') ||
            productTitle.includes('strickanleitung');
        }

        if (!isInstruction) {
          // Single bundles use variant-radios-bundle with color fieldsets
          var colorFieldsets = document.querySelectorAll('.single-bundle-color-fieldset');
          if (colorFieldsets[idx]) {
            var selectedImg = colorFieldsets[idx].querySelector('.multi-bundle-color-image');
            if (selectedImg) imageUrl = selectedImg.src || '';

            var nameEl = colorFieldsets[idx].querySelector('.color-name');
            if (nameEl) colorName = nameEl.textContent.trim();

            var titleEl = colorFieldsets[idx].querySelector('.prod-title');
            if (titleEl) label = titleEl.textContent.trim();

            // Fallback: legend text
            if (!label) {
              var legend = colorFieldsets[idx].querySelector('legend');
              if (legend) label = legend.textContent.trim().replace(/\s*–.*/, '');
            }
          }
        }

        // Instructions always get quantity 1
        if (isInstruction) qty = 1;

        slots.push({
          label: isInstruction ? 'Anleitung' : label,
          variantId: variantId,
          variantTitle: isInstruction ? (stockEl ? stockEl.getAttribute('data-product-title') || 'Strickanleitung' : 'Strickanleitung') : colorName,
          quantity: qty,
          imageUrl: imageUrl,
          isInstruction: isInstruction
        });
      });

      if (slots.length === 0) return null;

      var title = '';
      var h1 = document.querySelector('.product__title h1, .product__title');
      if (h1) title = h1.textContent.trim();

      var featuredImage = '';
      var featImgEl = document.querySelector('.product__media-item.is-active img, .product__media img');
      if (featImgEl) featuredImage = featImgEl.src || '';

      // Calculate price from replacer
      var totalPrice = 0;
      var priceEl = document.querySelector('price-money');
      if (priceEl) {
        var priceText = priceEl.textContent.replace(/[^\d,.]/g, '').replace(',', '.');
        totalPrice = parseFloat(priceText) * 100 || 0;
      }

      // Capture global options (size etc.) from select dropdowns
      var globalOptions = {};
      var sizeSelects = document.querySelectorAll('.bundle-size-select');
      sizeSelects.forEach(function (sel) {
        if (sel.value) {
          var wrapper = sel.closest('.bundle-size-dropdown, .product-form__input');
          var label = wrapper ? wrapper.querySelector('label, .form__label') : null;
          var key = label ? label.textContent.trim().replace(/:$/, '') : 'Größe';
          globalOptions[key] = sel.value;
        }
      });

      return {
        type: 'single',
        title: title,
        featuredImage: featuredImage,
        totalPrice: totalPrice,
        currency: 'EUR',
        globalOptions: globalOptions,
        slots: slots
      };
    },

    /**
     * Capture simple-bundle configuration from DOM.
     * Simple bundles have [data-bundle] inputs but no <bundle-variants> or <multi-bundle-handler>.
     */
    captureSimple: function () {
      var form = this._findProductForm();
      if (!form) return null;

      var idInputs = form.querySelectorAll('input[data-bundle]');
      if (idInputs.length === 0) return null;

      var qtyInputs = form.querySelectorAll('input[data-qtys-form]');
      var slots = [];

      // Color fieldsets from variant-radios-bundle (one per component)
      var colorFieldsets = document.querySelectorAll('.single-bundle-color-fieldset');

      idInputs.forEach(function (input, idx) {
        var variantId = input.value;
        var qty = qtyInputs[idx] ? parseInt(qtyInputs[idx].value) || 1 : 1;
        var price = input.getAttribute('data-price') || '0';

        var imageUrl = '';
        var colorName = '';
        var label = '';

        // Instruktions-Erkennung: data-variant-stock Elemente enthalten data-physical und data-product-title
        var isInstruction = false;
        var stockEl = document.querySelector('[data-variant-stock="' + variantId + '"]');
        if (stockEl) {
          var isPhysical = stockEl.getAttribute('data-physical');
          var productTitle = (stockEl.getAttribute('data-product-title') || '').toLowerCase();
          isInstruction = isPhysical === 'false' ||
            productTitle.includes('anleitung') ||
            productTitle.includes('strickanleitung');
        }

        if (!isInstruction) {
          // Match fieldset by index — fieldsets appear in the same order as bundle components
          if (colorFieldsets[idx]) {
            var selectedImg = colorFieldsets[idx].querySelector('.multi-bundle-color-image');
            if (selectedImg) imageUrl = selectedImg.src || '';

            var nameEl = colorFieldsets[idx].querySelector('.color-name');
            if (nameEl) colorName = nameEl.textContent.trim();

            var titleEl = colorFieldsets[idx].querySelector('.prod-title');
            if (titleEl) label = titleEl.textContent.trim();

            if (!label) {
              var legend = colorFieldsets[idx].querySelector('legend');
              if (legend) label = legend.textContent.trim().replace(/\s*–.*/, '');
            }
          }

          // Fallback label from data-bundle-component-label
          if (!label) {
            var labelEl = document.querySelector('[data-bundle-component-label="' + idx + '"]');
            if (labelEl) label = labelEl.getAttribute('data-label') || ('Farbe ' + (idx + 1));
          }
        }

        // Instructions always get quantity 1
        if (isInstruction) qty = 1;

        slots.push({
          label: isInstruction ? 'Anleitung' : (label || ('Farbe ' + (idx + 1))),
          variantId: variantId,
          variantTitle: isInstruction ? (stockEl ? stockEl.getAttribute('data-product-title') || 'Strickanleitung' : 'Strickanleitung') : colorName,
          quantity: qty,
          imageUrl: imageUrl,
          price: parseInt(price) || 0,
          isInstruction: isInstruction
        });
      });

      if (slots.length === 0) return null;

      var title = '';
      var h1 = document.querySelector('.product__title h1, .product__title');
      if (h1) title = h1.textContent.trim();

      var featuredImage = '';
      var featImgEl = document.querySelector('.product__media-item.is-active img, .product__media img');
      if (featImgEl) featuredImage = featImgEl.src || '';

      // Price from the page
      var totalPrice = 0;
      var priceEl = document.querySelector('price-money');
      if (priceEl) {
        var priceText = priceEl.textContent.replace(/[^\d,.]/g, '').replace(',', '.');
        totalPrice = parseFloat(priceText) * 100 || 0;
      }

      // Global options (size)
      var globalOptions = {};
      var sizeSelects = document.querySelectorAll('.bundle-size-select');
      sizeSelects.forEach(function (sel) {
        if (sel.value) {
          var wrapper = sel.closest('.bundle-size-dropdown, .product-form__input');
          var lbl = wrapper ? wrapper.querySelector('label, .form__label') : null;
          var key = lbl ? lbl.textContent.trim().replace(/:$/, '') : 'Größe';
          globalOptions[key] = sel.value;
        }
      });

      return {
        type: 'simple',
        title: title,
        featuredImage: featuredImage,
        totalPrice: totalPrice,
        currency: 'EUR',
        globalOptions: globalOptions,
        slots: slots
      };
    },

    /**
     * Capture current bundle state (auto-detects type).
     */
    capture: function () {
      var type = this.detectType();
      if (type === 'strickset') return this.captureStrickset();
      if (type === 'multi') return this.captureMulti();
      if (type === 'single') return this.captureSingle();
      if (type === 'simple') return this.captureSimple();
      return null;
    }
  };

  /* ── Store ── */

  var store = {
    items: [],
    customerId: null,
    customerMetafieldItems: null,

    init: function () {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (raw) this.items = JSON.parse(raw);
      } catch (e) {
        this.items = [];
      }

      var custEl = document.getElementById('lianne-wishlist-customer');
      if (custEl) {
        try {
          var custData = JSON.parse(custEl.textContent);
          this.customerId = custData.customerId || null;
          if (custData.wishlistItems && custData.wishlistItems.length > 0) {
            this.customerMetafieldItems = custData.wishlistItems;
          }
        } catch (e) { /* ignore */ }
      }

      if (this.customerId && this.customerMetafieldItems) {
        try { this._merge(this.customerMetafieldItems); } catch (e) { /* ignore */ }
      }

      this._save();
      try { this._updateAllHearts(); } catch (e) { /* ignore */ }
      this._updateBadge();
    },

    _merge: function (serverItems) {
      var existing = {};
      this.items.forEach(function (item) {
        existing[item.handle + '::' + (item.variantId || '') + '::' + (item.isBundle ? 'bundle' : '')] = true;
      });
      var changed = false;
      serverItems.forEach(function (item) {
        var key = item.handle + '::' + (item.variantId || '') + '::' + (item.isBundle ? 'bundle' : '');
        if (!existing[key]) {
          store.items.push(item);
          existing[key] = true;
          changed = true;
        }
      });
      if (changed) this._syncToServer();
    },

    add: function (handle, variantId, bundleData) {
      if (bundleData) {
        // For bundles: remove existing bundle entry for this handle, then add new one
        this.items = this.items.filter(function (item) {
          return !(item.handle === handle && item.isBundle);
        });
        this.items.push({
          handle: handle,
          variantId: variantId || '',
          isBundle: true,
          bundleData: bundleData
        });
      } else {
        if (this.has(handle, variantId)) return;
        this.items.push({ handle: handle, variantId: variantId || '' });
      }
      this._save();
      this._updateBadge();
      this._syncToServer();
    },

    remove: function (handle, variantId, isBundle) {
      this.items = this.items.filter(function (item) {
        if (isBundle) {
          return !(item.handle === handle && item.isBundle);
        }
        return !(item.handle === handle && item.variantId === (variantId || '') && !item.isBundle);
      });
      this._save();
      this._updateBadge();
      this._syncToServer();
    },

    toggle: function (handle, variantId, bundleData) {
      if (bundleData) {
        // Bundles: if already in wishlist, remove; otherwise add with new config
        var hasBundle = this.items.some(function (item) {
          return item.handle === handle && item.isBundle;
        });
        if (hasBundle) {
          this.remove(handle, '', true);
          return false;
        } else {
          this.add(handle, variantId, bundleData);
          return true;
        }
      }
      if (this.has(handle, variantId)) {
        this.remove(handle, variantId);
        return false;
      } else {
        this.add(handle, variantId);
        return true;
      }
    },

    has: function (handle, variantId) {
      return this.items.some(function (item) {
        return item.handle === handle && item.variantId === (variantId || '') && !item.isBundle;
      });
    },

    hasBundle: function (handle) {
      return this.items.some(function (item) {
        return item.handle === handle && item.isBundle;
      });
    },

    hasAny: function (handle) {
      return this.items.some(function (item) {
        return item.handle === handle;
      });
    },

    count: function () {
      return this.items.length;
    },

    getAll: function () {
      return this.items.slice();
    },

    _save: function () {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
      } catch (e) { /* storage full */ }
    },

    _syncToServer: function () {
      if (!this.customerId || !WORKER_URL) return;
      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: this.customerId, items: this.items })
      }).catch(function () { /* silent fail */ });
    },

    _updateBadge: function () {
      var badges = document.querySelectorAll('.wishlist-count-bubble');
      var count = this.count();
      badges.forEach(function (badge) {
        var span = badge.querySelector('[data-wishlist-count]');
        if (span) span.textContent = count;
        badge.classList.toggle('is-visible', count > 0);
      });
    },

    _updateAllHearts: function () {
      var hearts = document.querySelectorAll('.wishlist-heart');
      hearts.forEach(function (btn) {
        var handle = btn.getAttribute('data-handle');
        var variantId = btn.getAttribute('data-variant-id') || '';
        var isBundle = btn.hasAttribute('data-bundle');
        var active;

        if (isBundle) {
          active = store.hasBundle(handle);
        } else if (variantId === '') {
          active = store.hasAny(handle);
        } else {
          active = store.has(handle, variantId);
        }

        btn.classList.toggle('is-active', active);
      });
    }
  };

  /* ── Heart Button Click Handler ── */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-heart');
    if (!btn) return;

    // Bug-Fix: Tooltip-Link ("Zum Strickset →") durchlassen — nicht blockieren
    if (e.target.closest('.wishlist-bundle-tooltip__link')) return;

    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-handle');
    var variantId = btn.getAttribute('data-variant-id') || '';
    var isBundle = btn.hasAttribute('data-bundle');
    var added;

    if (isBundle) {
      // Determine if we're on a product page vs. a product card in the grid
      var onProductPage = btn.classList.contains('wishlist-heart--product');
      if (!onProductPage) {
        // Grid: Wenn Bundle bereits auf Wunschliste → direkt entfernen
        if (store.hasBundle(handle)) {
          store.remove(handle, '', true);
          added = false;
        } else {
          // Grid: Tooltip anzeigen — Bundle muss erst auf der Produktseite konfiguriert werden
          var existing = btn.querySelector('.wishlist-bundle-tooltip');
          if (existing) existing.remove();
          var tooltip = document.createElement('div');
          tooltip.className = 'wishlist-bundle-tooltip';
          tooltip.innerHTML = '<span class="wishlist-bundle-tooltip__text">Bitte konfiguriere zuerst Farben & Größe</span>'
            + '<a href="/products/' + handle + '" class="wishlist-bundle-tooltip__link">Zum Strickset &rarr;</a>';
          btn.style.overflow = 'visible';
          btn.appendChild(tooltip);
          // Tooltip im Viewport halten (vor allem für Karten am linken Rand auf Mobile)
          requestAnimationFrame(function () {
            var rect = tooltip.getBoundingClientRect();
            if (rect.left < 8) {
              tooltip.style.right = 'auto';
              tooltip.style.left = '0';
              var arrow = tooltip.querySelector('::before') || null;
              // Pfeil-Position über CSS-Variable anpassen
              tooltip.style.setProperty('--arrow-right', 'auto');
              tooltip.style.setProperty('--arrow-left', '1.2rem');
            }
            if (rect.right > window.innerWidth - 8) {
              tooltip.style.right = '0';
              tooltip.style.left = 'auto';
            }
          });
          // Remove on click outside or after 4s
          var removeTooltip = function (evt) {
            if (evt && tooltip.contains(evt.target)) return;
            if (tooltip.parentNode) tooltip.remove();
            document.removeEventListener('click', removeTooltip, true);
          };
          setTimeout(function () {
            document.addEventListener('click', removeTooltip, true);
          }, 0);
          setTimeout(function () { removeTooltip(); }, 4000);
          return;
        }
      } else {
        // Produktseite: Bundle konfiguration speichern/aktualisieren
        var bundleData = bundleCapture.capture();
        if (!bundleData) {
          // Kein Bundle-Config (einfaches Strickset) → normales Toggle
          added = store.toggle(handle, variantId);
        } else {
          bundleData.allowPartialRemoval = btn.hasAttribute('data-bundle-partial-removal');
          var wasAlreadySaved = store.hasBundle(handle);
          if (wasAlreadySaved && !btn.classList.contains('has-update')) {
            // Gleiche Konfiguration → entfernen (normales Toggle-off)
            store.remove(handle, '', true);
            added = false;
          } else {
            // Neue Konfiguration oder noch nicht gespeichert → speichern/ersetzen
            store.add(handle, '', bundleData);
            added = true;
            if (wasAlreadySaved) {
              // Konfiguration aktualisiert → Toast + Badge entfernen
              showWishlistToast(bundleData);
              btn.classList.remove('has-update');
              var hint = btn.querySelector('.wishlist-update-hint');
              if (hint) hint.remove();
              var badge = btn.querySelector('.wishlist-refresh-badge');
              if (badge) badge.remove();
            }
          }
        }
      }
    } else {
      added = store.toggle(handle, variantId);
    }

    // Visual feedback
    btn.classList.toggle('is-active', added);
    btn.classList.add('is-animating');
    setTimeout(function () {
      btn.classList.remove('is-animating');
    }, 500);

    // Update all hearts for same product
    document.querySelectorAll('.wishlist-heart[data-handle="' + handle + '"]').forEach(function (h) {
      if (h !== btn) h.classList.toggle('is-active', added);
    });
  });

  /* ── Variant Change Tracking (Product Page, non-bundle) ── */

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    // Skip on bundle pages — bundles handle their own state
    if (bundleCapture.detectType()) return;

    var hearts = document.querySelectorAll('.wishlist-heart--product:not([data-bundle])');
    hearts.forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var newVariantId = String(variant.id);
      btn.setAttribute('data-variant-id', newVariantId);
      btn.classList.toggle('is-active', store.has(handle, newVariantId));
    });
  });

  /* ── Strickset Konfigurations-Änderungs-Hint ── */

  function updateStricksetWishlistHint() {
    var heart = document.querySelector('.wishlist-heart--product[data-bundle]');
    if (!heart) return;
    var handle = heart.getAttribute('data-handle');
    if (!store.hasBundle(handle)) return;

    var savedItem = store.getAll().find(function (i) { return i.handle === handle && i.isBundle; });
    if (!savedItem || !savedItem.bundleData) return;

    // Aktuelle Konfiguration über bundleCapture lesen (funktioniert für alle Bundle-Typen)
    var currentData = bundleCapture.capture();
    var currentSize = currentData && currentData.globalOptions
      ? Object.values(currentData.globalOptions).filter(Boolean).join(' / ')
      : '';

    var savedSize = savedItem.bundleData.globalOptions
      ? Object.values(savedItem.bundleData.globalOptions).filter(Boolean).join(' / ')
      : '';

    var hint = heart.querySelector('.wishlist-update-hint');
    var badge = heart.querySelector('.wishlist-refresh-badge');

    if (currentSize && savedSize && currentSize !== savedSize) {
      heart.style.overflow = 'visible';
      heart.classList.add('has-update');

      if (!hint) {
        hint = document.createElement('div');
        hint.className = 'wishlist-update-hint';
        heart.appendChild(hint);
      }
      hint.textContent = 'Mit ' + currentSize + ' aktualisieren';

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'wishlist-refresh-badge';
        badge.innerHTML = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">'
          + '<path d="M13.5 8A5.5 5.5 0 1 1 8 2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>'
          + '<polyline points="8,2.5 11,2.5 11,5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
          + '</svg>';
        heart.appendChild(badge);
      }
    } else {
      heart.classList.remove('has-update');
      if (hint) hint.remove();
      if (badge) badge.remove();
    }
  }

  // Größenänderung: alle Bundle-Systeme (neu + alt)
  document.addEventListener('change', function (e) {
    if (e.target.matches(
      '.strickset-size-select, .strickset-dimension-select, ' +
      '.bundle-size-select, .multi-bundle-size-select, ' +
      'multi-bundle-options input, bundle-options input'
    )) {
      updateStricksetWishlistHint();
    }
  });

  // Farbwechsel: neues System
  document.addEventListener('strickset:variant-changed', function () {
    updateStricksetWishlistHint();
  });

  // Farbwechsel: altes System (variant:change wird von MultiBundleHandler gefeuert)
  document.addEventListener('variant:change', function () {
    if (bundleCapture.detectType()) updateStricksetWishlistHint();
  });

  /* ── Share Functions ── */

  var share = {
    generateUrl: function () {
      var items = store.getAll();
      if (items.length === 0) return window.location.href;
      var parts = items.map(function (item) {
        var s = item.handle;
        if (item.variantId) s += ':' + item.variantId;
        if (item.isBundle) s += '!b';
        return s;
      });
      return window.location.origin + '/pages/wunschliste?w=' + encodeURIComponent(parts.join(','));
    },

    parseCompactUrl: function (param) {
      if (!param) return [];
      return param.split(',').map(function (part) {
        var isBundle = part.indexOf('!b') !== -1;
        part = part.replace('!b', '');
        var pieces = part.split(':');
        var item = { handle: pieces[0], variantId: pieces[1] || '' };
        if (isBundle) item.isBundle = true;
        return item;
      }).filter(function (item) { return item.handle; });
    },

    copyLink: function (buttonEl) {
      var url = this.generateUrl();
      navigator.clipboard.writeText(url).then(function () {
        buttonEl.classList.add('wishlist-share__btn--copied');
        var origText = buttonEl.querySelector('span');
        if (origText) {
          var prev = origText.textContent;
          origText.textContent = 'Kopiert!';
          setTimeout(function () {
            origText.textContent = prev;
            buttonEl.classList.remove('wishlist-share__btn--copied');
          }, 2000);
        }
      });
    },

    shareByEmail: function () {
      var url = this.generateUrl();
      var subject = encodeURIComponent('Meine Wunschliste bei Lianne');
      var body = encodeURIComponent('Schau dir meine Wunschliste an:\n\n' + url);
      var mailto = 'mailto:?subject=' + subject + '&body=' + body;
      var iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = mailto;
      document.body.appendChild(iframe);
      setTimeout(function () { document.body.removeChild(iframe); }, 1000);
    }
  };

  /* ── Share Button Handlers ── */

  document.addEventListener('click', function (e) {
    var copyBtn = e.target.closest('[data-wishlist-copy]');
    if (copyBtn) {
      e.preventDefault();
      share.copyLink(copyBtn);
      return;
    }
    var emailBtn = e.target.closest('[data-wishlist-email]');
    if (emailBtn) {
      e.preventDefault();
      share.shareByEmail();
    }
  });

  /* ── Wishlist Page Renderer ── */

  var page = {
    container: null,

    init: function () {
      this.container = document.getElementById('wishlist-page-content');
      if (!this.container) return;

      var params = new URLSearchParams(window.location.search);
      var compactParam = params.get('w');
      if (compactParam) {
        var sharedItems = share.parseCompactUrl(compactParam);
        if (sharedItems.length > 0) {
          this.renderSharedItems(sharedItems);
          return;
        }
      }
      var shared = params.get('shared');
      if (shared) {
        this.renderShared(shared);
        return;
      }

      this.render();
    },

    render: function () {
      var items = store.getAll();
      if (items.length === 0) {
        this.renderEmpty();
        return;
      }

      var countEl = document.querySelector('.wishlist-page__count');
      if (countEl) countEl.textContent = items.length + (items.length === 1 ? ' Produkt' : ' Produkte');

      var shareEl = document.querySelector('.wishlist-share');
      if (shareEl) shareEl.style.display = '';

      this.container.innerHTML = '<div class="wishlist-loading"><div class="wishlist-loading__spinner"></div></div>';

      // Separate bundle and regular items
      var regularItems = [];
      var bundleItems = [];
      items.forEach(function (item) {
        if (item.isBundle) {
          bundleItems.push(item);
        } else {
          regularItems.push(item);
        }
      });

      // Regular items need Storefront API fetch
      var regularHandles = regularItems.map(function (i) { return i.handle; });
      var uniqueHandles = regularHandles.filter(function (h, i) { return regularHandles.indexOf(h) === i; });

      if (uniqueHandles.length > 0) {
        this.fetchProducts(uniqueHandles).then(function (products) {
          page.renderAllCards(regularItems, products, bundleItems);
        }).catch(function () {
          page.renderAllCards(regularItems, {}, bundleItems);
        });
      } else {
        this.renderAllCards(regularItems, {}, bundleItems);
      }
    },

    renderShared: function (encoded) {
      try {
        var sharedItems = JSON.parse(decodeURIComponent(escape(atob(decodeURIComponent(encoded)))));
        if (!Array.isArray(sharedItems) || sharedItems.length === 0) {
          this.renderEmpty();
          return;
        }

        var titleEl = document.querySelector('.wishlist-page__title');
        if (titleEl) titleEl.textContent = 'Geteilte Wunschliste';
        var countEl = document.querySelector('.wishlist-page__count');
        if (countEl) countEl.textContent = sharedItems.length + (sharedItems.length === 1 ? ' Produkt' : ' Produkte');

        var shareEl = document.querySelector('.wishlist-share');
        if (shareEl) shareEl.style.display = 'none';

        this.container.innerHTML = '<div class="wishlist-loading"><div class="wishlist-loading__spinner"></div></div>';

        var regularItems = [];
        var bundleItems = [];
        sharedItems.forEach(function (item) {
          if (item.isBundle) bundleItems.push(item);
          else regularItems.push(item);
        });

        var handles = regularItems.map(function (i) { return i.handle; });
        var uniqueHandles = handles.filter(function (h, i) { return handles.indexOf(h) === i; });

        if (uniqueHandles.length > 0) {
          this.fetchProducts(uniqueHandles).then(function (products) {
            page.renderAllCards(regularItems, products, bundleItems);
          });
        } else {
          this.renderAllCards(regularItems, {}, bundleItems);
        }
      } catch (e) {
        this.renderEmpty();
      }
    },

    renderSharedItems: function (sharedItems) {
      var titleEl = document.querySelector('.wishlist-page__title');
      if (titleEl) titleEl.textContent = 'Geteilte Wunschliste';
      var countEl = document.querySelector('.wishlist-page__count');
      if (countEl) countEl.textContent = sharedItems.length + (sharedItems.length === 1 ? ' Produkt' : ' Produkte');

      var shareEl = document.querySelector('.wishlist-share');
      if (shareEl) shareEl.style.display = 'none';

      this.container.innerHTML = '<div class="wishlist-loading"><div class="wishlist-loading__spinner"></div></div>';

      var regularItems = [];
      var bundleItems = [];
      sharedItems.forEach(function (item) {
        if (item.isBundle) bundleItems.push(item);
        else regularItems.push(item);
      });

      var handles = regularItems.map(function (i) { return i.handle; });
      var uniqueHandles = handles.filter(function (h, i) { return handles.indexOf(h) === i; });

      if (uniqueHandles.length > 0) {
        this.fetchProducts(uniqueHandles).then(function (products) {
          page.renderAllCards(regularItems, products, bundleItems);
        }).catch(function () {
          page.renderAllCards(regularItems, {}, bundleItems);
        });
      } else {
        this.renderAllCards(regularItems, {}, bundleItems);
      }
    },

    fetchProducts: function (handles) {
      if (!STOREFRONT_TOKEN || !SHOP_DOMAIN) {
        return Promise.reject(new Error('No Storefront API config'));
      }

      var fragments = handles.map(function (h, i) {
        return 'p' + i + ': product(handle: "' + h + '") { handle title vendor productType featuredImage { url altText } priceRange { minVariantPrice { amount currencyCode } } variants(first: 100) { nodes { id title price { amount currencyCode } compareAtPrice { amount } image { url altText } availableForSale } } }';
      });
      var query = '{ ' + fragments.join(' ') + ' }';

      return fetch('https://' + SHOP_DOMAIN + '/api/2025-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: query })
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          var map = {};
          if (json.data) {
            Object.keys(json.data).forEach(function (key) {
              var p = json.data[key];
              if (p && p.handle) map[p.handle] = p;
            });
          }
          if (json.errors) console.warn('Wishlist Storefront API errors:', json.errors);
          return map;
        });
    },

    renderAllCards: function (regularItems, products, bundleItems) {
      var html = '<div class="wishlist-grid">';

      // Render regular product cards
      regularItems.forEach(function (item) {
        html += page.renderRegularCard(item, products);
      });

      // Render bundle cards
      bundleItems.forEach(function (item) {
        html += page.renderBundleCard(item);
      });

      html += '</div>';
      this.container.innerHTML = html;
    },

    renderRegularCard: function (item, products) {
      var product = products[item.handle];
      if (!product) return '';

      var variant = product.variants.nodes[0];
      if (item.variantId) {
        var itemVid = String(item.variantId);
        var found = product.variants.nodes.find(function (v) {
          return v.id === itemVid || v.id === 'gid://shopify/ProductVariant/' + itemVid || v.id.replace('gid://shopify/ProductVariant/', '') === itemVid;
        });
        if (found) variant = found;
      }

      var imgSource = (variant.image && variant.image.url) ? variant.image : product.featuredImage;
      var rawImgUrl = imgSource ? imgSource.url : '';
      var imgUrl = rawImgUrl ? rawImgUrl + (rawImgUrl.indexOf('?') !== -1 ? '&' : '?') + 'width=600' : '';
      var imgAlt = imgSource ? (imgSource.altText || product.title) : product.title;
      var price = parseFloat(variant.price.amount).toFixed(2).replace('.', ',');
      var currency = variant.price.currencyCode === 'EUR' ? '\u20AC' : variant.price.currencyCode;
      var compareHtml = '';
      if (variant.compareAtPrice && parseFloat(variant.compareAtPrice.amount) > parseFloat(variant.price.amount)) {
        var compare = parseFloat(variant.compareAtPrice.amount).toFixed(2).replace('.', ',');
        compareHtml = '<span class="compare-price">' + compare + ' ' + currency + '</span>';
      }

      var variantTitle = variant.title !== 'Default Title' ? variant.title : '';
      var variantIdClean = variant.id.replace('gid://shopify/ProductVariant/', '');
      var disabledAttr = variant.availableForSale ? '' : ' disabled';
      var atcText = variant.availableForSale ? 'In den Warenkorb' : 'Ausverkauft';

      // Events & Kurse: no direct ATC, link to product page instead
      var pType = (product.productType || '').toLowerCase();
      var isEvent = pType === 'events' || pType === 'kurs';

      var html = '<div class="wishlist-card" data-handle="' + item.handle + '" data-variant-id="' + (item.variantId || '') + '">';
      html += '<div class="wishlist-card__image-wrap">';
      if (imgUrl) html += '<a href="/products/' + item.handle + '"><img src="' + imgUrl + '" alt="' + imgAlt + '" loading="lazy"></a>';
      html += '<button class="wishlist-card__remove" data-wishlist-remove="' + item.handle + '" data-variant-id="' + (item.variantId || '') + '" aria-label="Entfernen">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6.4C8.8 8.6 11.6 11.2 13.8 13.6C15.4 15.4 16.8 17 17.6 18.2"/><path d="M17.8 5.8C15.2 7.8 12.6 10.6 10.4 13C8.8 14.8 7.2 16.4 6 17.8C5.8 18.1 6 18.4 6.4 18.2"/></svg>';
      html += '</button></div>';
      html += '<div class="wishlist-card__info">';
      if (product.vendor) html += '<p class="wishlist-card__vendor">' + product.vendor + '</p>';
      html += '<h3 class="wishlist-card__title"><a href="/products/' + item.handle + '">' + product.title + '</a></h3>';
      if (variantTitle) html += '<p class="wishlist-card__variant">' + variantTitle + '</p>';
      html += '<p class="wishlist-card__price">' + price + ' ' + currency + compareHtml + '</p>';
      if (isEvent) {
        html += '<a href="/products/' + item.handle + '" class="wishlist-card__atc wishlist-card__atc--event">Termin ausw\u00E4hlen</a>';
      } else {
        html += '<button class="wishlist-card__atc" data-variant-id="' + variantIdClean + '"' + disabledAttr + '>' + atcText + '</button>';
      }
      html += '</div></div>';
      return html;
    },

    renderBundleCard: function (item) {
      var bd = item.bundleData;
      if (!bd) return '';

      var featImg = bd.featuredImage || '';
      var imgTag = featImg ? '<img src="' + featImg + '" alt="' + (bd.title || '') + '" loading="lazy">' : '';

      // Format price
      var priceStr = '';
      if (bd.totalPrice) {
        priceStr = (bd.totalPrice / 100).toFixed(2).replace('.', ',') + ' \u20AC';
      }

      // Build color swatches row (skip instruction slots)
      var swatchesHtml = '<div class="wishlist-bundle__colors">';
      var hasInstruction = false;
      bd.slots.forEach(function (slot) {
        if (slot.isInstruction || slot.isAutoAdd) {
          if (slot.isInstruction) hasInstruction = true;
          return;
        }
        var thumbUrl = slot.imageUrl || '';
        if (thumbUrl) {
          thumbUrl = thumbUrl.split('?')[0] + '?width=80&height=80&crop=center';
        }
        swatchesHtml += '<div class="wishlist-bundle__color-slot">';
        if (thumbUrl) {
          swatchesHtml += '<img class="wishlist-bundle__color-thumb" src="' + thumbUrl + '" alt="' + (slot.variantTitle || '') + '">';
        }
        swatchesHtml += '<span class="wishlist-bundle__color-label">' + (slot.label || '') + '</span>';
        swatchesHtml += '<span class="wishlist-bundle__color-name">' + (slot.variantTitle || '') + '</span>';
        swatchesHtml += '</div>';
      });
      swatchesHtml += '</div>';
      if (hasInstruction) {
        swatchesHtml += '<p class="wishlist-bundle__includes-instruction">inkl. Strickanleitung</p>';
      }

      // Global options (size etc.)
      var optionsHtml = '';
      if (bd.globalOptions && Object.keys(bd.globalOptions).length > 0) {
        var opts = [];
        for (var key in bd.globalOptions) {
          if (bd.globalOptions.hasOwnProperty(key)) {
            opts.push(key + ': ' + bd.globalOptions[key]);
          }
        }
        optionsHtml = '<p class="wishlist-bundle__options">' + opts.join(' · ') + '</p>';
      }

      // Build bundle cart data as JSON for the ATC button
      var cartItems = [];
      var timestamp = Date.now();
      bd.slots.forEach(function (slot) {
        var vid = String(slot.variantId).replace('gid://shopify/ProductVariant/', '');
        var props = {
          'Bundle': bd.title || item.handle,
          '_BundleID': String(timestamp)
        };
        // Allow partial removal if set on the bundle
        if (bd.allowPartialRemoval) {
          props['_BundleAllowPartial'] = 'true';
        }
        // Add global options (e.g. Größe) as line item properties
        if (bd.globalOptions) {
          for (var optKey in bd.globalOptions) {
            if (bd.globalOptions.hasOwnProperty(optKey)) {
              props[optKey] = bd.globalOptions[optKey];
            }
          }
        }
        // Gratis-Anleitung Property für Discount Function
        if (slot.isInstruction && slot.isFree) {
          props['_gratis_anleitung'] = 'true';
        }
        cartItems.push({
          id: parseInt(vid, 10),
          quantity: slot.quantity,
          properties: props
        });
      });
      var cartDataAttr = encodeURIComponent(JSON.stringify(cartItems));

      var html = '<div class="wishlist-card wishlist-card--bundle" data-handle="' + item.handle + '" data-is-bundle="true">';
      html += '<div class="wishlist-card__image-wrap">';
      if (imgTag) html += '<a href="/products/' + item.handle + '">' + imgTag + '</a>';
      html += '<span class="wishlist-card__bundle-badge">Strickset</span>';
      html += '<button class="wishlist-card__remove" data-wishlist-remove="' + item.handle + '" data-is-bundle="true" aria-label="Entfernen">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6.4C8.8 8.6 11.6 11.2 13.8 13.6C15.4 15.4 16.8 17 17.6 18.2"/><path d="M17.8 5.8C15.2 7.8 12.6 10.6 10.4 13C8.8 14.8 7.2 16.4 6 17.8C5.8 18.1 6 18.4 6.4 18.2"/></svg>';
      html += '</button></div>';
      html += '<div class="wishlist-card__info">';
      html += '<h3 class="wishlist-card__title"><a href="/products/' + item.handle + '">' + (bd.title || item.handle) + '</a></h3>';
      html += optionsHtml;
      html += swatchesHtml;
      if (priceStr) html += '<p class="wishlist-card__price">' + priceStr + '</p>';
      html += '<button class="wishlist-card__atc wishlist-card__atc--bundle" data-bundle-cart="' + cartDataAttr + '">In den Warenkorb</button>';
      html += '<a href="/products/' + item.handle + '" class="wishlist-bundle__edit">Konfiguration \u00E4ndern</a>';
      html += '</div></div>';
      return html;
    },

    renderEmpty: function () {
      var countEl = document.querySelector('.wishlist-page__count');
      if (countEl) countEl.textContent = '';
      var shareEl = document.querySelector('.wishlist-share');
      if (shareEl) shareEl.style.display = 'none';

      this.container.innerHTML =
        '<div class="wishlist-empty">' +
        '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M11.8 7.4C10.4 4.2 4.8 4 4 8.6C3.2 13 7.6 17.2 11.2 19.8C11.6 20.1 12 20.1 12.4 19.8C16.4 17 20.6 13 20.4 8.2C20.2 4.4 15.6 3.4 13.2 5.8C12.6 6.4 12.2 7 11.9 8"/></svg>' +
        '<h2 class="wishlist-empty__title">Deine Wunschliste ist leer</h2>' +
        '<p class="wishlist-empty__text">Entdecke unsere Produkte und speichere deine Favoriten.</p>' +
        '<a href="/collections/all" class="wishlist-empty__cta">Produkte entdecken</a>' +
        '</div>';
    }
  };

  /* ── Remove from wishlist page ── */

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    var handle = removeBtn.getAttribute('data-wishlist-remove');
    var isBundle = removeBtn.hasAttribute('data-is-bundle');
    var variantId = removeBtn.getAttribute('data-variant-id') || '';
    var card = removeBtn.closest('.wishlist-card');

    var doRemove = function () {
      store.remove(handle, variantId, isBundle);
      store._updateAllHearts();
      page.render();
    };

    if (card) {
      card.classList.add('is-removing');
      setTimeout(doRemove, 300);
    } else {
      doRemove();
    }
  });

  /* ── Add to cart from wishlist page ── */

  function refreshCartDrawer() {
    // Fetch updated cart sections and refresh the mini-cart drawer
    var sections = 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble';
    fetch('/cart.js?sections=' + sections)
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var miniCart = document.querySelector('mini-cart');
        if (miniCart && miniCart.renderContents) {
          miniCart.renderContents({ sections: cart.sections || cart });
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        // Fallback: reload page if sections fetch fails
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  document.addEventListener('click', function (e) {
    var atcBtn = e.target.closest('.wishlist-card__atc');
    if (!atcBtn) return;
    // Let event/kurs links navigate normally
    if (atcBtn.classList.contains('wishlist-card__atc--event')) return;
    e.preventDefault();

    // Build items array (bundle or regular)
    var items;
    var bundleCartData = atcBtn.getAttribute('data-bundle-cart');
    if (bundleCartData) {
      items = JSON.parse(decodeURIComponent(bundleCartData));
    } else {
      var variantId = atcBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      items = [{ id: parseInt(variantId, 10), quantity: 1 }];
    }

    atcBtn.disabled = true;
    atcBtn.textContent = 'Wird hinzugef\u00FCgt\u2026';

    // Add sections param so Shopify returns rendered HTML for cart drawer
    var sectionsParam = 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionsParam })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (response) {
        atcBtn.textContent = 'Hinzugef\u00FCgt \u2713';
        setTimeout(function () {
          atcBtn.textContent = 'In den Warenkorb';
          atcBtn.disabled = false;
        }, 2000);

        // Refresh cart drawer with returned sections
        var miniCart = document.querySelector('mini-cart');
        if (miniCart && miniCart.renderContents && response.sections) {
          miniCart.renderContents(response);
        } else {
          refreshCartDrawer();
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (err) {
        var errMsg = (err && err.description) || (err && err.message) || '';
        var isStockError = errMsg && (errMsg.toLowerCase().includes('verf\u00FCgbarkeit') || errMsg.toLowerCase().includes('stock') || errMsg.toLowerCase().includes('quantity'));

        if (isStockError) {
          atcBtn.textContent = 'Teilweise hinzugef\u00FCgt';
          refreshCartDrawer();
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } else {
          atcBtn.textContent = 'Nicht verf\u00FCgbar';
        }

        // Fehlermeldung unter dem Button anzeigen
        var card = atcBtn.closest('.wishlist-card');
        if (errMsg && card) {
          var existing = card.querySelector('.wishlist-card__error');
          if (existing) existing.remove();
          var errEl = document.createElement('p');
          errEl.className = 'wishlist-card__error';
          errEl.style.cssText = 'color:#c0392b;font-size:1.2rem;margin:0.5rem 0 0;text-align:center;';
          errEl.textContent = isStockError ? 'Nicht alle Artikel sind in der gew\u00FCnschten Menge verf\u00FCgbar. Bitte Konfiguration \u00E4ndern.' : errMsg;
          atcBtn.parentNode.insertBefore(errEl, atcBtn.nextSibling);
          setTimeout(function () { if (errEl.parentNode) errEl.remove(); }, 8000);
        }

        setTimeout(function () {
          atcBtn.textContent = 'In den Warenkorb';
          atcBtn.disabled = false;
        }, 4000);
      });
  });

  /* ── Wishlist Drawer ── */

  var drawer = {
    el: null,
    overlay: null,
    body: null,
    isOpen: false,
    productCache: {},

    init: function () {
      this.el = document.getElementById('wishlist-drawer');
      this.overlay = document.getElementById('wishlist-drawer-overlay');
      this.body = document.getElementById('wishlist-drawer-body');

      // Skip on wishlist page — let header link navigate normally
      this.isWishlistPage = !!document.getElementById('wishlist-page-content');

      if (!this.el) return;

      // Move drawer and overlay to body root to escape header stacking context
      if (this.overlay) document.body.appendChild(this.overlay);
      document.body.appendChild(this.el);

      // Close button
      var closeBtn = this.el.querySelector('[data-wishlist-drawer-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () { drawer.close(); });
      }

      // Overlay click closes
      if (this.overlay) {
        this.overlay.addEventListener('click', function () { drawer.close(); });
      }

      // Click anywhere outside drawer closes it and blocks the underlying click
      document.addEventListener('click', function (e) {
        if (!drawer.isOpen) return;
        // Clicks inside the drawer are fine
        if (drawer.el.contains(e.target)) return;
        // Clicks on the overlay are handled above
        if (drawer.overlay && drawer.overlay.contains(e.target)) return;
        // Clicks on the toggle button (heart icon) are handled separately
        if (e.target.closest('[data-wishlist-drawer-toggle]')) return;
        // Everything else: close drawer and block the click
        e.preventDefault();
        e.stopPropagation();
        drawer.close();
      }, true);

      // ESC key closes
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.isOpen) drawer.close();
      });

      // Share button handlers within drawer
      this.el.addEventListener('click', function (e) {
        var shareBtn = e.target.closest('[data-wishlist-share]');
        if (!shareBtn) return;
        e.preventDefault();
        var type = shareBtn.getAttribute('data-wishlist-share');
        drawer.handleShare(type, shareBtn);
      });

      // Remove item handler within drawer
      this.el.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('.wishlist-drawer-item__remove');
        if (!removeBtn) return;
        e.preventDefault();
        var handle = removeBtn.getAttribute('data-handle');
        var isBundle = removeBtn.hasAttribute('data-is-bundle');
        var variantId = removeBtn.getAttribute('data-variant-id') || '';
        var item = removeBtn.closest('.wishlist-drawer-item');
        if (item) {
          item.style.opacity = '0';
          item.style.transform = 'translateX(2rem)';
          item.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
        }
        setTimeout(function () {
          store.remove(handle, variantId, isBundle);
          store._updateAllHearts();
          drawer.render();
          // Also re-render wishlist page if open
          if (page.container) page.render();
        }, 250);
      });
    },

    open: function () {
      // Self-heal: re-resolve elements if init() failed or body went missing
      if (!this.el || !this.body) {
        this.el      = document.getElementById('wishlist-drawer');
        this.overlay = document.getElementById('wishlist-drawer-overlay');
        this.body    = document.getElementById('wishlist-drawer-body');
        if (!this.el) return;
        // Move to body root only if not already there
        if (this.overlay && this.overlay.parentNode !== document.body) {
          document.body.appendChild(this.overlay);
        }
        if (this.el.parentNode !== document.body) {
          document.body.appendChild(this.el);
        }
        // Re-bind close button (might not have been bound in failed init)
        var self = this;
        var closeBtn = this.el.querySelector('[data-wishlist-drawer-close]');
        if (closeBtn && !closeBtn._wlBound) {
          closeBtn._wlBound = true;
          closeBtn.addEventListener('click', function () { self.close(); });
        }
        if (this.overlay && !this.overlay._wlBound) {
          this.overlay._wlBound = true;
          this.overlay.addEventListener('click', function () { self.close(); });
        }
      }
      if (this.isOpen) return;
      this.isOpen = true;
      document.body.classList.add('wishlist-drawer-open');
      this.el.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      this.render();
    },

    close: function () {
      if (!this.el || !this.isOpen) return;
      this.isOpen = false;
      this.el.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.classList.remove('wishlist-drawer-open');
    },

    render: function () {
      if (!this.body) return;
      var items = store.getAll();

      if (items.length === 0) {
        this.body.innerHTML = this.renderEmpty();
        // Hide share row & footer when empty
        var shareRow = this.el.querySelector('.wishlist-drawer__share');
        var footer = this.el.querySelector('.wishlist-drawer__footer');
        if (shareRow) shareRow.style.display = 'none';
        if (footer) footer.style.display = 'none';
        return;
      }

      // Show share row & footer
      var shareRow = this.el.querySelector('.wishlist-drawer__share');
      var footer = this.el.querySelector('.wishlist-drawer__footer');
      if (shareRow) shareRow.style.display = '';
      if (footer) footer.style.display = '';

      // Separate items
      var regularItems = [];
      var bundleItems = [];
      items.forEach(function (item) {
        if (item.isBundle) bundleItems.push(item);
        else regularItems.push(item);
      });

      // Get unique handles for regular items
      var handles = regularItems.map(function (i) { return i.handle; });
      var uniqueHandles = handles.filter(function (h, i) { return handles.indexOf(h) === i; });

      // Check cache: which handles need fetching?
      var needFetch = uniqueHandles.filter(function (h) { return !drawer.productCache[h]; });

      if (needFetch.length > 0) {
        this.body.innerHTML = '<div class="wishlist-loading"><div class="wishlist-loading__spinner"></div></div>';
        this.fetchProducts(needFetch).then(function (products) {
          // Merge into cache
          for (var h in products) {
            if (products.hasOwnProperty(h)) drawer.productCache[h] = products[h];
          }
          drawer.renderItems(regularItems, bundleItems);
        }).catch(function () {
          drawer.renderItems(regularItems, bundleItems);
        });
      } else {
        this.renderItems(regularItems, bundleItems);
      }
    },

    fetchProducts: function (handles) {
      if (!STOREFRONT_TOKEN || !SHOP_DOMAIN) return Promise.reject();
      var fragments = handles.map(function (h, i) {
        return 'p' + i + ': product(handle: "' + h + '") { handle title vendor productType featuredImage { url altText } priceRange { minVariantPrice { amount currencyCode } } variants(first: 100) { nodes { id title price { amount currencyCode } compareAtPrice { amount } image { url altText } availableForSale } } }';
      });
      var query = '{ ' + fragments.join(' ') + ' }';
      return fetch('https://' + SHOP_DOMAIN + '/api/2025-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: query })
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          var map = {};
          if (json.data) {
            Object.keys(json.data).forEach(function (key) {
              var p = json.data[key];
              if (p && p.handle) map[p.handle] = p;
            });
          }
          return map;
        });
    },

    renderItems: function (regularItems, bundleItems) {
      var html = '';

      regularItems.forEach(function (item) {
        var product = drawer.productCache[item.handle];
        if (!product) return;

        var variant = product.variants.nodes[0];
        if (item.variantId) {
          var vid = String(item.variantId);
          var found = product.variants.nodes.find(function (v) {
            return v.id === vid || v.id === 'gid://shopify/ProductVariant/' + vid || v.id.replace('gid://shopify/ProductVariant/', '') === vid;
          });
          if (found) variant = found;
        }

        var imgUrl = product.featuredImage ? product.featuredImage.url : '';
        if (variant.image && variant.image.url) imgUrl = variant.image.url;
        if (imgUrl) imgUrl = imgUrl.split('?')[0] + '?width=200&height=200&crop=center';
        var imgAlt = product.featuredImage ? (product.featuredImage.altText || product.title) : product.title;

        var price = parseFloat(variant.price.amount).toFixed(2).replace('.', ',');
        var currency = variant.price.currencyCode === 'EUR' ? '\u20AC' : variant.price.currencyCode;
        var variantTitle = variant.title !== 'Default Title' ? variant.title : '';

        html += '<div class="wishlist-drawer-item">';
        html += '<div class="wishlist-drawer-item__image">';
        if (imgUrl) html += '<a href="/products/' + item.handle + '"><img src="' + imgUrl + '" alt="' + imgAlt + '" loading="lazy"></a>';
        html += '</div>';
        html += '<div class="wishlist-drawer-item__info">';
        if (product.vendor) html += '<p class="wishlist-drawer-item__vendor">' + product.vendor + '</p>';
        html += '<p class="wishlist-drawer-item__title"><a href="/products/' + item.handle + '">' + product.title + '</a></p>';
        if (variantTitle) html += '<p class="wishlist-drawer-item__variant">' + variantTitle + '</p>';
        html += '<p class="wishlist-drawer-item__price">' + price + ' ' + currency + '</p>';
        html += '</div>';
        html += '<button class="wishlist-drawer-item__remove" data-handle="' + item.handle + '" data-variant-id="' + (item.variantId || '') + '" aria-label="Entfernen">';
        html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6.4C8.8 8.6 11.6 11.2 13.8 13.6C15.4 15.4 16.8 17 17.6 18.2"/><path d="M17.8 5.8C15.2 7.8 12.6 10.6 10.4 13C8.8 14.8 7.2 16.4 6 17.8C5.8 18.1 6 18.4 6.4 18.2"/></svg>';
        html += '</button></div>';
      });

      bundleItems.forEach(function (item) {
        var bd = item.bundleData;
        if (!bd) return;

        var imgUrl = bd.featuredImage || '';
        if (imgUrl) imgUrl = imgUrl.split('?')[0] + '?width=200&height=200&crop=center';

        var priceStr = '';
        if (bd.totalPrice) {
          priceStr = (bd.totalPrice / 100).toFixed(2).replace('.', ',') + ' \u20AC';
        }

        // Compact color info
        var colorInfo = '';
        var colorCount = 0;
        bd.slots.forEach(function (slot) {
          if (!slot.isInstruction && !slot.isAutoAdd) colorCount++;
        });
        if (colorCount > 0) colorInfo = colorCount + (colorCount === 1 ? ' Farbe' : ' Farben');

        // Size info
        var sizeInfo = '';
        if (bd.globalOptions) {
          var sizeParts = [];
          for (var key in bd.globalOptions) {
            if (bd.globalOptions.hasOwnProperty(key)) {
              sizeParts.push(key + ': ' + bd.globalOptions[key]);
            }
          }
          sizeInfo = sizeParts.join(' · ');
        }

        html += '<div class="wishlist-drawer-item">';
        html += '<div class="wishlist-drawer-item__image">';
        if (imgUrl) html += '<a href="/products/' + item.handle + '"><img src="' + imgUrl + '" alt="' + (bd.title || '') + '" loading="lazy"></a>';
        html += '</div>';
        html += '<div class="wishlist-drawer-item__info">';
        html += '<p class="wishlist-drawer-item__title"><a href="/products/' + item.handle + '">' + (bd.title || item.handle) + '</a></p>';
        html += '<span class="wishlist-drawer-item__bundle-tag">Strickset</span>';
        if (colorInfo || sizeInfo) {
          html += '<p class="wishlist-drawer-item__variant">';
          html += [colorInfo, sizeInfo].filter(Boolean).join(' · ');
          html += '</p>';
        }
        if (priceStr) html += '<p class="wishlist-drawer-item__price">' + priceStr + '</p>';
        html += '</div>';
        html += '<button class="wishlist-drawer-item__remove" data-handle="' + item.handle + '" data-is-bundle aria-label="Entfernen">';
        html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6.4C8.8 8.6 11.6 11.2 13.8 13.6C15.4 15.4 16.8 17 17.6 18.2"/><path d="M17.8 5.8C15.2 7.8 12.6 10.6 10.4 13C8.8 14.8 7.2 16.4 6 17.8C5.8 18.1 6 18.4 6.4 18.2"/></svg>';
        html += '</button></div>';
      });

      this.body.innerHTML = html;
    },

    renderEmpty: function () {
      return '<div class="wishlist-drawer__empty">' +
        '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M11.8 7.4C10.4 4.2 4.8 4 4 8.6C3.2 13 7.6 17.2 11.2 19.8C11.6 20.1 12 20.1 12.4 19.8C16.4 17 20.6 13 20.4 8.2C20.2 4.4 15.6 3.4 13.2 5.8C12.6 6.4 12.2 7 11.9 8"/></svg>' +
        '<h3 class="wishlist-drawer__empty-title">Liebst du es? F\u00FCge es deinem Wunschzettel hinzu</h3>' +
        '<p class="wishlist-drawer__empty-text">Hier sammelst du alles, was dein Strickherz h\u00F6her schlagen l\u00E4sst. Speichere deine Favoriten \u2013 f\u00FCr sp\u00E4ter, f\u00FCr Inspiration oder f\u00FCr deinen n\u00E4chsten Besuch bei uns im Laden.</p>' +
        '<a href="/collections/all" class="wishlist-drawer__empty-cta">Produkte entdecken</a>' +
        '</div>';
    },

    handleShare: function (type, btnEl) {
      var url = share.generateUrl();
      var text = encodeURIComponent('Schau dir meine Wunschliste bei Lianne an!');

      switch (type) {
        case 'facebook':
          window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank', 'width=600,height=400');
          break;
        case 'pinterest':
          window.open('https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&description=' + text, '_blank', 'width=600,height=400');
          break;
        case 'whatsapp':
          window.open('https://wa.me/?text=' + text + '%20' + encodeURIComponent(url), '_blank');
          break;
        case 'email':
          share.shareByEmail();
          break;
        case 'copy':
          share.copyLink(btnEl);
          // Visual feedback for copy
          btnEl.classList.add('wishlist-drawer__share-btn--copied');
          setTimeout(function () {
            btnEl.classList.remove('wishlist-drawer__share-btn--copied');
          }, 2000);
          break;
      }
    }
  };

  /* ── Toast: Konfiguration aktualisiert ── */

  function showWishlistToast(bundleData) {
    var existing = document.getElementById('wishlist-update-toast');
    if (existing) existing.remove();

    // Größe aus globalOptions
    var sizePart = '';
    if (bundleData.globalOptions) {
      var opts = Object.values(bundleData.globalOptions).filter(Boolean);
      if (opts.length) sizePart = opts.join(' · ');
    }

    // Erste Farbe (kein Anleitung-Slot)
    var firstColor = '';
    if (bundleData.slots) {
      var colorSlot = bundleData.slots.find(function (s) { return !s.isInstruction && s.variantTitle; });
      if (colorSlot) firstColor = colorSlot.variantTitle;
    }

    var detail = [sizePart, firstColor].filter(Boolean).join(' · ');
    var msg = 'Gespeichert' + (detail ? ': ' + detail : '') + ' ✓';

    var toast = document.createElement('div');
    toast.id = 'wishlist-update-toast';
    toast.className = 'wishlist-update-toast';
    toast.textContent = msg;
    document.body.appendChild(toast);

    // Einblenden
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('is-visible');
      });
    });

    // Nach 3s ausblenden und entfernen
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        if (toast.parentNode) toast.remove();
      }, 400);
    }, 3000);
  }

  /* ── Init ── */

  function initWishlist() {
    try { store.init(); } catch(e) { /* ignore */ }
    try { drawer.init(); } catch(e) { /* ignore */ }
    try { page.init(); } catch(e) { /* ignore */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlist);
  } else {
    initWishlist();
  }

  window.LianneWishlist = {
    store: store,
    share: share,
    drawer: drawer,
    bundleCapture: bundleCapture
  };
})();
